import { kitchenSinkRules } from './rules/kitchenSink';
import { applicationRules } from './rules/application';

export const rules = {
    kitchenSink: kitchenSinkRules,
    application: applicationRules,
};
